module.exports = __webpack_public_path__ + "static/Genoapay_logo-60c3eac92a75e804d8d2e1354a666d84.png";